import CustomBreadCrumb from '../../../constants/CustomBreadCrumb'
import CustomCard from '../../../constants/CustomCard'

const EquipServiceReportsPage = () => {
  const items = [
    {
      title: 'EQUIPMENT LIST',
      to: '/equipment-list-report',
      linkName: 'Equipment List Report'
    },{
      title: 'FAULTY SUMMARY',
      to: '/faulty-report',
      linkName: 'Faulty Report'
    },{
      title: 'BACKLOG SUMMARY',
      to: '/backlog-report',
      linkName: 'Backlog Summary Report'
    },{
      title: 'ACTIVITY',
      to: '/activity-report',
      linkName: 'Activity Report'
    }
  ]
  return (
    <>
      <CustomBreadCrumb title={'Equipment Service Reports'} isReport={false} isDashboard={false} />
      <div className="row mt-5 g-8">
        {
          items.map((item, index) => (
              <div key={index} className='col-xl-3'>
                <CustomCard url={item?.to} title={item?.title} />
              </div>
            )
          )
        }
      </div>
    </>
  );
}

export default EquipServiceReportsPage;